import { isDev } from "../general";
import main from "../../../package.json";

// static class Version
export class Version {
  public static getVersion(): string {
    return main.version;
  }
  public static appName(): string {
    return `Web Booking System ${this.getVersion()} - ${this.getDate()}${isDev() ? " - DEV" : ""}`;
  }
  public static getApplicationName(): string {
    return `Web Booking System ${this.getVersion()}`;
  }
  public static appNameShort(): string {
    return `WBS-${this.getVersion()}`;
  }
  public static getDate(): string {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, "0");
    const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    const yyyy = today.getFullYear();
    return `${yyyy}-${mm}-${dd}`;
  }
  public static getApplicationId(): number {
    return 23;
  }
  public static getBookingSourceId(): number {
    return 100;
  }
  public static getAuthor(): { fullName: string; email: string } {
    return { fullName: "Adam Rzymski", email: "adam.rzymski@rightio.co.uk" };
  }
}
//
// Language: typescript
// Path: ClientApp\src\utils\version\index.ts

export default Version;
